import { Component, OnInit } from '@angular/core';
import { LoadingAndErrors } from '../../../../classes';
import { Pagination } from '../../../../interfaces';
import { DiscountsService, OrderingService } from '../../../../services';
import { LoopBackConfig, OrderApi, LoopBackAuth } from '../../../../../assets/js/lb-sdk';
import { BsModalService } from 'ngx-bootstrap';
import { ProductDetailsComponent } from '../../product-details/product-details.component';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { PAYMENT_TYPE, USER_ROLES } from '../../../../enums';
// import { ProductsService} from '../../../../services';
import { ProductsService } from  '@app/services/products.service';


@Component({
  selector: 'app-order-form',
  templateUrl: './order-form.component.html',
  styleUrls: ['./order-form.component.css']
})
export class OrderFormComponent extends LoadingAndErrors implements OnInit {
  USER_ROLES: typeof USER_ROLES = USER_ROLES;
  host:string = LoopBackConfig.getPath();
  searchText: string;
  pagination: Pagination = {
    page: 1,
    total: 0,
    limit: 12,
    limitOptions: [12, 24, 60, 84, 120]
  };
  orders: {[key:string]: number} = {};
  state;

  constructor(
    private route: ActivatedRoute,
    public productService: ProductsService,
    public discountService: DiscountsService,
    public orderingService: OrderingService,
    private orderApi: OrderApi,
    private modalService: BsModalService,
    private toast: ToastrService,
    private router: Router,
    private loopBackAuth: LoopBackAuth
  ) {
    super();
  }

  ngOnInit() {
    this.route.paramMap
      .subscribe(params => {
        this.state = {...params};
        if (this.state.params && this.state.params.id) {
          this.loading.order = true;
          this.clearErrors();
          this.orderApi
            .findById(this.state.params.id, {
              include: 'orderItems'
            })
            .pipe(finalize(() => {
              this.loading.order = false;
            }))
            .subscribe((order: any) => {
              this.orders = (order.orderItems || [])
                .reduce((orders, order) => {
                  orders[order.productType + order.planType] = order.quantity;
                  return orders;
                }, {});
            }, error => {
              this.errors.order = error.message || 'Unable to load Order details';
            });
        } else {
          this.orders = localStorage.getItem('orders') ? JSON.parse(localStorage.getItem('orders')) : {};
        }
      });
  }

  formatLink(product) {
    const host = this.host;
    return `${host}/api/ProductImages/link/${(product.productType || {}).name}/${product.planTypeCode}`;
  }

  getPagination():Pagination {
    if (!this.productService.isLoading()) {
      const {
        page,
        limit,
        limitOptions
      } = this.pagination;
      this.pagination = {
        page,
        limit,
        limitOptions,
        total: this.productService.getActiveProducts().length
      }
    }
    return this.pagination;
  }

  showProduct(product):void {
    const productDetailsModal = this.modalService
      .show(ProductDetailsComponent, {
        initialState: { product: product }
      });
    const subscription = this.modalService.onHidden
      .subscribe(() => {
        if (productDetailsModal.content) {
          if (productDetailsModal.content.result) {

          } else {

          }
        }
        subscription.unsubscribe();
      });
  }

  addOrder(product) {
    this.orders[(product.productType || {}).name + product.planTypeCode] = (this.orders[(product.productType || {}).name + product.planTypeCode] || 0) + 1;
    this.saveToLocalStorage();
  }

  subtractOrder(product) {
    this.orders[(product.productType || {}).name + product.planTypeCode] = (this.orders[(product.productType || {}).name + product.planTypeCode] || 0) - 1;
    this.saveToLocalStorage();
  }

  onPageChange(pagination: Pagination) {
    this.pagination = pagination;
  }

  clearOrders() {
    this.orders = {};
    this.saveToLocalStorage();
  }

  saveToLocalStorage() {
    if (!this.state || !this.state.params || !this.state.params.id) {
      localStorage.setItem('orders', JSON.stringify(this.orders));
    }
  }

  save() {
    this.clearErrors();
    this.loading.update = true;
    this.orderApi
      .patchAttributes(this.state.params.id, {
        items: this.orderingService
          .getProductOrders(this.orders)
          .map(product => {
            return {
              productType: (product.productType || {}).name,
              planType: (product || {}).planTypeCode,
              quantity: this.orders[(product.productType || {}).name + product.planTypeCode]
            };
          })
      })
      .pipe(finalize(() => {
        this.loading.update = false;
      }))
      .subscribe(response => {
        this.toast.success('Order successfully updated', 'Update Order');
        this.router.navigateByUrl('/orders/' + this.state.params.id + '/payment');
      }, error => {
        this.errors.update = error && error.message || 'Failed to update order.';
      });
  }

  // removePrepaidForCreditTerms(products: any[]): any[] {
  //   if (!products || !products.length) {
  //     return [];
  //   }
  //   if (this.hasPaymentType(PAYMENT_TYPE.CREDIT_TERMS)) {
  //     return products.filter(product => {
  //       return (product.productType || {}).name === 'ZPRM';
  //     });
  //   } else {
  //     return products;
  //   }
  // }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }

  // hasPaymentType(type) {
  //   if (!this.getUser()) {
  //     return false;
  //   }
  //   return (this.getUser().roles || [])
  //     .filter(role => {
  //       return role.paymentType === type;
  //     }).length > 0;
  // }
}
